/* global SUPPORT_EMAIL, SUPPORT_PHONE */
import { h } from 'preact'

const email = SUPPORT_EMAIL
const phone = SUPPORT_PHONE

const ErrorContactInfo = () => (
  <p>
    <a href='mailto:{email}' class='text-muted'>{email}</a>
    <br />Phone: <a href='tel:+1-{phone}' class='text-muted'>{phone}</a>
  </p>
)

export default ErrorContactInfo
